import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';

export const getDiet = async (dietName, dietQuality, userId) => {
  // userId is optional but it makes no sense to make the call without diet vars
  if (!dietName || !dietQuality) {
    return false;
  }

  const apiURL = API_HOST + '/diets/' + dietName + '/' + dietQuality + '?u=' + userId;
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
